<nav class="bottom-nav" aria-label="Navegação principal">
	@for (item of items; track item.link) {
		<a class="bottom-nav__item" [routerLink]="item.link" [class.active]="isActive(item)" [attr.aria-current]="isActive(item) ? 'page' : null">
			<span class="bottom-nav__icon">
				<fa-icon [icon]="item.icon" [fixedWidth]="true"></fa-icon>
			</span>
			<span class="bottom-nav__label">{{ item.label }}</span>
		</a>
	}
</nav>
